import * as XLSX from 'xlsx';
import { ApiData } from '../../../../../../contexts/apiService';

export const downloadT1 = (
    finalTableData: Record<string, any>[],
    apiData: ApiData | null,
    currentMonthFilter?: string,
) => {
    if (!finalTableData || finalTableData.length === 0) {
        alert('No data available for T1 form generation');
        return;
    }

    const currentMonth = currentMonthFilter ? new Date(currentMonthFilter) : new Date();

    const dataToUse = finalTableData.filter(row => row.status === 'Completed');

    type AggregationRecord = {
        producer: string;
        lease: string;
        station_owner: string;
        destination: string;
        total_net_barrels: number;
        ticket_count: number;
    };

    const aggregationMap = new Map<string, AggregationRecord>();

    dataToUse.forEach(row => {
        const { producer, lease, station_owner, destination } = row;
        const netBarrels = Number(row.net_barrels);
        const key = `${producer}|${lease}|${station_owner}|${destination}`;

        if (!aggregationMap.has(key)) {
            aggregationMap.set(key, { producer, lease, station_owner, destination, total_net_barrels: 0, ticket_count: 0 });
        }

        const record = aggregationMap.get(key)!;
        record.total_net_barrels += netBarrels;
        record.ticket_count += 1;
    });

    const aggregatedData: any[] = [];

    aggregationMap.forEach(record => {
        aggregatedData.push({
            'Origin State': apiData?.lease_coordinates?.find(
                lc => lc.lease === record.lease && lc.producer_name === record.producer
            )?.state || '',
            'Producer': record.producer,
            'Entity': apiData?.lease_coordinates?.find(
                lc => lc.lease === record.lease && lc.producer_name === record.producer
            )?.entity || '',
            'Lease': record.lease,
            'Destination State': apiData?.market_coordinates?.find(
                sc => sc.market === record.station_owner && sc.station === record.destination
            )?.state || '',
            'Station Owner': record.station_owner,
            'Destination': record.destination,
            'Total Net Barrels': Number(record.total_net_barrels.toFixed(2)),
            'Ticket Count': record.ticket_count,
            'Month': currentMonth.toLocaleString('en-US', { month: 'long' }),
            'Year': currentMonth.getFullYear(),
        });
    });

    aggregatedData.sort((a, b) =>
        a.Producer.localeCompare(b.Producer) ||
        a.Lease.localeCompare(b.Lease) ||
        a['Station Owner'].localeCompare(b['Station Owner']) ||
        a.Destination.localeCompare(b.Destination)
    );

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(aggregatedData);

    worksheet['!cols'] = [
        { wch: 20 }, { wch: 20 }, { wch: 25 }, { wch: 25 }, { wch: 20 },
        { wch: 20 }, { wch: 25 }, { wch: 15 }, { wch: 12 }, { wch: 10 }, { wch: 8 },
    ];

    XLSX.utils.book_append_sheet(workbook, worksheet, 'T1 Aggregated Data');

    const monthYear = currentMonth.toLocaleString('en-US', { month: 'long', year: 'numeric' }).replace(' ', '_');
    XLSX.writeFile(workbook, `T1_Form_${monthYear}.xlsx`);
};